import { Children, ReactNode, isValidElement } from 'react';
import classNames from 'classnames';

type CardFlipProps = {
  flipped: boolean;
  children: ReactNode;
  className?: string;
  id?: string;
};

export default function CardFlip({ flipped, children, className, id }: CardFlipProps) {
  const front = Children.toArray(children).find(child => isValidElement(child) && child.props['data-slot'] === 'front');
  const back = Children.toArray(children).find(child => isValidElement(child) && child.props['data-slot'] === 'back');
  const audio = Children.toArray(children).find(child => isValidElement(child) && child.props['data-slot'] === 'audio');

  return (
    <div className={classNames('card-flip-wrapper', className)} data-testid={id}>
      {audio}
      <div className={`card-flip flip-along-x ${flipped ? 'flipped' : ''}`}>
        {front && <div className="card-flip-face card-flip-front">{front}</div>}
        {back && <div className="card-flip-face card-flip-back">{back}</div>}
      </div>
    </div>
  );
}
